export const formatData = (data, channels, dataKey = "realPower") => {
  const seriesNames = [];
  const formattedData = data.map((datum) => {
    const formattedDatum = {
      time: new Date(datum.timestamp * 1000),
    };

    datum.channelData.forEach((channelDatum) => {
      // find the corresponding channel
      const channel = channels.find(
        (channel) => channel.id === channelDatum.channelId
      );

      if (channel && channel.name) {
        if (
          channel.name.toLowerCase().includes("grid") ||
          channel.categoryLabel.toLowerCase().includes("grid")
        ) {
          // if grid
          formattedDatum.Grid = aggregateByLabelSubString(
            "Grid",
            channelDatum,
            formattedDatum
          );
          pushIfDoesntExist(seriesNames, "Grid");
        } else if (
          channel.name.toLowerCase().includes("solar") ||
          channel.categoryLabel.toLowerCase().includes("solar")
        ) {
          // if solar
          formattedDatum.Solar = aggregateByLabelSubString(
            "Solar",
            channelDatum,
            formattedDatum
          );
          pushIfDoesntExist(seriesNames, "Solar");
        } else {
          // other
          formattedDatum[channel.name] = channelDatum;
          pushIfDoesntExist(seriesNames, channel.name);
        }
      }
    });

    return Object.entries(formattedDatum).reduce(
      (acc, [name, channelDatum]) => {
        if (name !== "time") {
          return { ...acc, ...flattenChannelDatum(channelDatum, name) };
        } else {
          acc.time = channelDatum;
          return acc;
        }
      },
      {}
    );
  });
  return { formattedData, seriesNames };
};

const pushIfDoesntExist = (array, str) =>
  !array.find((item) => item === str) && array.push(str);

const flattenChannelDatum = (datum, name) =>
  Object.entries(datum).reduce((acc, [dataKey, value]) => {
    acc[`${name}:${dataKey}`] = value;
    return acc;
  }, {});

const aggregateByLabelSubString = (subString, channelDatum, currentData) => {
  if (!currentData[subString]) {
    return channelDatum;
  } else {
    return combineChannelData(currentData[subString], channelDatum);
  }
};

const combineChannelData = (channelDatum1, channelDatum2) => {
  const output = {};
  const ignore = ["channelId"];

  Object.keys(channelDatum1).map((key) => {
    if (!ignore.find((ignoreKey) => key === ignoreKey)) {
      output[key] = channelDatum1[key] + channelDatum2[key];
    }
  });

  return output;
};

export const getRecentData = (newData, currentData) => {
  const newBuff = newData;
  const recentTimestamp = currentData[currentData.length - 1].time.getTime();

  // find the new data index where the datums are more recent than the most recent current data
  const newDataIndex = newBuff.findIndex((newDatum) => {
    return newDatum.time.getTime() > recentTimestamp;
  });

  return newData.slice(newDataIndex);
};

export const getChannelColors = () => [
  "#2492D2",
  "#24A21A",
  "#FFB50A",
  "#CC1C00",
  "#9D4D24",
  "#5E5D63",
];

export const toTitleCase = (str) =>
  str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/LiveMeterGraph/LiveMeterGraph.utils.js